import { __rest, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';

var NvList = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, type = _a.type, props = __rest(_a, ["children", "className", "type"]);
    var classNames = "nv-".concat(type, "-list ").concat(className);
    var Element = type === 'bulleted' ? 'ul' : 'ol';
    return (React.createElement(Element, __assign({}, props, { className: classNames }), children));
};

export { NvList as default };
//# sourceMappingURL=NvList.esm.js.map
